module.exports = __webpack_public_path__ + "img/PT502733209.7e5e55aa.png";